import React, { useState } from "react";
import "./menuKit.css";
import plusSquare from "../../../../assets/u400c/plus-square.png";
import trash from "../../../../assets/u400c/trash.png";
import info from "../../../../assets/u400c/info.png";
import Info from "../info";
import imgPlaceholder from "../../../../assets/imgPlaceholder.png";
import tvsPlaceholder from "../../../../assets/accessories_Placeholder_img.png";

const MenuKit = ({
  data,
  AccessoriesIndex,
  PartNumIndex,
  onCart,
  add,
  onAddCartWarning,
}) => {
  const [modalVisiblity, setModalVisiblity] = useState(false);

  return (
    <>
      <div className="safety-header">
        <img
          className="default-img"
          src={data?.Images[0] || imgPlaceholder}
          onError={(e) => {
            e.target.src = tvsPlaceholder;
          }}
          alt="default"
        ></img>
        <div className="safety-text-container">
          <div className="safety-text">
            <div className="text-with-icon mediumFont">
              <p>
                {data?.Name}
                <img
                  src={info}
                  alt="Icon"
                  className="info-icon"
                  onClick={() => setModalVisiblity(true)}
                />
              </p>
            </div>

            <div className="safety-price mediumFont">
              {"Rs " + data?.Price + "/-"}
            </div>
          </div>
          {/* <div className="safety-texture">
            {data?.Images.map((item) => (
              <img src={item} alt="item"></img>
            ))}
          </div> */}
        </div>
        <img
          className="safety-cart"
          src={add ? trash : plusSquare}
          style={{
            opacity: data?.disable && 0.5,
            cursor: "pointer",
          }}
          onClick={() => {
            if (!data?.disable) {
              onCart(
                data?.Name,
                data?.Price,
                data?.ProductCode,
                data?.Catogery,
                AccessoriesIndex,
                PartNumIndex,
                !add
              );
            } else {
              onAddCartWarning(data?.ProductCode);
            }
          }}
          alt="cart"
        />
      </div>
      <Info
        setModalVisiblity={setModalVisiblity}
        modalVisiblity={modalVisiblity}
        data={data}
        add={add}
        disable={data?.disable}
        AccessoriesIndex={AccessoriesIndex}
        PartNumIndex={PartNumIndex}
        onPress={() =>
          onCart(
            data?.Name,
            data?.Price,
            data?.ProductCode,
            data?.Catogery,
            AccessoriesIndex,
            PartNumIndex,
            !add
          )
        }
      />
    </>
  );
};

export default MenuKit;
